import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import 'moment-timezone';
import { IHaveVersions } from '../interfaces';
import { TIMELINE_SIMULATOR_FORM2_CONSTANTS } from '../../workspace-v2/timeline-generator/timeline-simulator/models/timeline-criteria-form2-constants';

export type CampaignName = 'Campaign' | 'Drive Campaign' | null;

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  /**
   * Return default image for no avatar
   */
  public getAvatarNoImage(): string {
    return environment.web.baseUrl + '/assets/img/misc/avatar-no-image.png';
  }

  /**
   * Return default image for no group image
   */
  public getGroupNoImage(): string {
    return environment.web.baseUrl + '/assets/img/misc/group-no-image.png';
  }

  /**
   * Return default audio image
   */
  public getAudioImage(): string {
    return environment.web.baseUrl + '/assets/img/misc/audio.png';
  }

  /**
   * Fix avatar url
   * @param avatarUrl
   * @param version
   */
  public getFixedAvatarUrl(avatarUrl: string, version: number | string = null): string {
    // If avatar url is saved in google and dont have alt=media param, then add it
    if (avatarUrl.indexOf('googleapis') >= 0 && avatarUrl.indexOf('alt=media') < 0) {
      avatarUrl += '?alt=media&_v=' + version;
    }
    return avatarUrl;
  }

  public getCurrentPageVersion(page: IHaveVersions): number {
    let currentVersion: number = 1;

    if (page.versions.length > 0) {
      currentVersion = page.versions[0].versionNumber;
    }

    return currentVersion;
  }

  public getOptionPreviewUrl(page: IHaveVersions, file: Partial<{ id: string; [key: string]: string }>): string {
    const version: number = this.getCurrentPageVersion(page);
    return `/projects/${page.projectId}/${page.sectionId}/${page.subsectionId}/preview?directLink=true&version=${version}&fileId=${file.id}#${page.optionId}`;
  }

  public getCurrentOrigin(): string {
    return environment.production ? `https:${environment.web.baseUrl}` : window.location.origin;
  }

  public translateConfigCampaignNameToLocalizationKey(configCampaignName: CampaignName, type: string): string | null {
    if (configCampaignName === 'Campaign') {
      return 'campaign_' + type;
    } else if (configCampaignName === 'Drive Campaign') {
      return 'drive_campaign_' + type;
    }
    return null;
  }

  public mapCriteriaFormTypeToComponentName(criteriaForm: string): string | null {
    if (criteriaForm === 'CRITERIA_FORM_TIMELINE_2') {
      return TIMELINE_SIMULATOR_FORM2_CONSTANTS.FORM_COMPONENT_NAME;
    }
    return null;
  }

  public buildDownloadQuery(file: any, quality?: string): string | null {
    const params: string[] = [];
    if (file?.sectionId) {
      params.push(`sectionId=${file.sectionId}`);
    }
    if (file?.subSectionId) {
      params.push(`subSectionId=${file.subSectionId}`);
    }
    if (quality) {
      params.push(`thumbnail=${quality}`);
    }
    return params.length > 0 ? `?${params.join('&')}` : null;
  }
}
